import { inject, Injectable } from '@angular/core'
import { AssistantService } from '../../../services/domain/assistant/assistant.service'
import { Assistant } from '../../../models/assistant'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AssistantDropdownService {
  private assistantService = inject(AssistantService)

  getAllAssistants(): Observable<Assistant[]> {
    return this.assistantService
      .getAllActiveWithUserAndKeyCoordinatorWithCaching()
      .pipe(map((aa) => aa.sort(Assistant.sortByName)))
  }
}
